import { Link, useNavigate, Outlet } from "react-router-dom";
import { Avatar, Dropdown, Typography } from "antd";
import { DownOutlined, LogoutOutlined } from "@ant-design/icons";
import Logo from "../assets/img/om-full-primary-logo.svg";
import { useAuth } from "../context/AuthContext";
import { notifyUser } from "../utils/notify";

const { Text } = Typography;

/**
 * Same shell as EasyLife's own DashboardLayout — fixed navbar, logo, profile
 * dropdown, and (matching EasyLife) no persistent page-nav links; getting to
 * My Claims / New Claim happens from the Dashboard itself.
 */
const PortalLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const displayName = user?.name || "Portal User";
  const displayRole = user?.role || "";
  const initials = displayName.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0].toUpperCase()).join("");

  const handleLogout = async () => {
    await logout();
    notifyUser("success", "You have been signed out.", "Signed out");
    navigate("/login");
  };

  const menuItems = [
    {
      key: "profile-header",
      label: (
        <div style={{ display: "flex", flexDirection: "column", padding: "4px 0" }}>
          <Text strong style={{ marginBottom: 0 }}>{displayName}</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>{displayRole}{user?.organisation ? ` · ${user.organisation}` : ""}</Text>
        </div>
      ),
      disabled: true,
    },
    { type: "divider" },
    {
      key: "logout",
      label: <span style={{ color: "#ff4d4f" }}><LogoutOutlined style={{ marginRight: 8 }} />Sign out</span>,
      onClick: handleLogout,
    },
  ];

  return (
    <div style={{ minHeight: "100vh" }}>
      <nav
        className="navbar navbar-expand-lg app-navbar"
        style={{
          position: "fixed", width: "100%", top: 0, zIndex: 1000,
          backgroundColor: "var(--bg-navbar)", boxShadow: "var(--shadow-navbar)", height: 70,
        }}
      >
        <div className="container-fluid d-flex justify-content-between align-items-center px-3">
          <Link className="navbar-brand d-flex align-items-center" to="/dashboard" style={{ gap: 8 }}>
            <img src={Logo} alt="Old Mutual" style={{ height: 30, width: "auto" }} />
            <span style={{ fontWeight: 700, fontSize: 16, color: "var(--text-primary)", letterSpacing: "0.02em" }}>
              Corporate Claims
            </span>
          </Link>

          <div className="d-flex align-items-center" style={{ gap: 20 }}>
            <Dropdown menu={{ items: menuItems }} trigger={["click"]} placement="bottomRight">
              <button
                className="btn btn-light border-0"
                style={{
                  padding: "4px 12px", borderRadius: 999, background: "var(--bg-card)",
                  border: "1px solid var(--border-color)", boxShadow: "var(--shadow-card)",
                  display: "flex", alignItems: "center", gap: 8,
                }}
              >
                <Avatar size={30} style={{ background: "linear-gradient(135deg,#0b6efd,#22c55e,#06b6d4)", fontSize: 12, fontWeight: 600 }}>
                  {initials}
                </Avatar>
                <span style={{ fontSize: 13.5, fontWeight: 600, color: "var(--text-primary)" }}>{displayName}</span>
                <DownOutlined style={{ fontSize: 10, color: "var(--text-secondary)" }} />
              </button>
            </Dropdown>
          </div>
        </div>
      </nav>

      <div className="portal-content">
        <div className="container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PortalLayout;
